import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const OpeningHoursNormal = ({ selected }) => {
  const [expanded, setExpanded] = useState(0);

  return (
    <div className="openingHours__normal">
      <div className="openingHours__header" onClick={() => setExpanded(!expanded)}>
        <h4>Öffnungszeiten</h4>
        <motion.div
          initial="collapsed"
          animate={expanded ? "open" : "collapsed"}
          exit="collapsed"
          variants={{
            open: {
              rotate: [0, 0, 90],
              transition: { duration: 0.4 }
            },
            collapsed: {
              rotate: [90, 0, 0],
              transition: { duration: 0.4, delay: 0.6 }
            }
          }}
          className="arrow"
        />
      </div>
      <AnimatePresence initial={false}>
        {expanded && (
          <motion.div
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { opacity: 1, height: "auto", transition: { duration: 0.8, delay: 0.4 } },
              collapsed: { opacity: 0, height: 0, transition: { duration: 1 } }
            }}
            className="openingHours__normal--grid"
          >
            <div className="openingHours__normal--row">
              <span>Mo:</span>
              <span>{selected.openingHoursFields.mondayOpeningHours || 'Geschlossen'}</span>
            </div>
            <div className="openingHours__normal--row">
              <span>Di:</span>
              <span>{selected.openingHoursFields.tuesdayOpeningHours || 'Geschlossen'}</span>
            </div>
            <div className="openingHours__normal--row">
              <span>Mi:</span>
              <span>{selected.openingHoursFields.wednesdayOpeningHours || 'Geschlossen'}</span>
            </div>
            <div className="openingHours__normal--row">
              <span>Do:</span>
              <span>{selected.openingHoursFields.thursdayOpeningHours || 'Geschlossen'}</span>
            </div>
            <div className="openingHours__normal--row">
              <span>Fr:</span>
              <span>{selected.openingHoursFields.fridayOpeningHours || 'Geschlossen'}</span>
            </div>
            <div className="openingHours__normal--row">
              <span>Sa:</span>
              <span>{selected.openingHoursFields.saturdayOpeningHours || 'Geschlossen'}</span>
            </div>
            <div className="openingHours__normal--row">
              <span>So:</span>
              <span>{selected.openingHoursFields.sundayOpeningHours || 'Geschlossen'}</span>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default OpeningHoursNormal;
